import { apiJson } from '../../shared/api/http';

export interface SearchResults {
  events: SearchEvent[];
  courses: SearchCourse[];
  people: SearchPerson[];
}

export interface SearchEvent {
  id: string;
  title: string;
  type: string | null;
  date_start: string | null;
  thumbnail_url: string | null;
  city: string | null;
}

export interface SearchCourse {
  id: string;
  title: string;
  category: string | null;
  difficulty: string | null;
  thumbnail_url: string | null;
}

export interface SearchPerson {
  id: string;
  name: string;
  email: string | null;
  avatar: string | null;
  department: string | null;
  role: string | null;
}

export function searchGlobal(query: string): Promise<SearchResults> {
  return apiJson(`/api/search?q=${encodeURIComponent(query)}`, { auth: true });
}
